import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';

import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';

import Router from './routes';
import Loader from './components/Loader';

import faviconUrl from './assets/login-logo-transparente.png';

export default function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  });

  return (
    <ThemeConfig>
      <GlobalStyles />
      <Helmet>
        <title>MSM Autogestión</title>
        <link rel="shortcut icon" href={ faviconUrl } />
      </Helmet>
      {
        loading
          ? <Loader loading={true} />
          : <Router />
      }
    </ThemeConfig>
  );
}
